/**
 * Homepage "Naše glavne usluge" cards.
 *
 * Every entry must point at the canonical page for that service so Google sees
 * one page per service (no cannibalisation between a service card, a blog and a
 * redirect). Prices are the clinic's published rates — never invent one here.
 */
export type HomepageService = {
  id: string;
  href: string;
  img: string;
  titleKey: string;
  descriptionKey: string;
  /** Published price, e.g. "3.500 RSD". */
  price: string;
  /** True when the price is a minimum and needs the localized "od/from/от" prefix. */
  priceFrom?: boolean;
};

export const HOMEPAGE_SERVICES: HomepageService[] = [
  {
    id: 'kiropraktika',
    href: '/kiropraktika-novi-beograd',
    img: '/images/kiropraktika-novi-beograd.webp',
    titleKey: 'services.chiro.title',
    descriptionKey: 'services.chiro.description',
    price: '5.000 RSD',
  },
  {
    id: 'limfna-drenaza',
    href: '/limfna-drenaza-novi-beograd',
    img: '/images/services/limfna-drenaza.webp',
    titleKey: 'services.lymphaticDrainage.title',
    descriptionKey: 'services.lymphaticDrainage.description',
    // Published as a range (3.500 / 6.000 RSD); the card shows the lowest rate.
    price: '3.500 RSD',
    priceFrom: true,
  },
  {
    id: 'shockwave',
    href: '/shockwave-terapija-novi-beograd',
    img: '/images/shockwave-therapy.webp',
    titleKey: 'services.shockwaveTherapy.title',
    descriptionKey: 'services.shockwaveTherapy.description',
    price: '3.000 RSD',
  },
  {
    id: 'fizikalna-terapija',
    href: '/fizikalna-terapija-novi-beograd',
    img: '/images/fizikalna-terapija-novi-beograd.webp',
    titleKey: 'services.physio.title',
    descriptionKey: 'services.physio.description',
    price: '2.500 RSD',
  },
];
